<template>
  <div>
      <v-btn @click="click">
        가져온값
      </v-btn> 
      <div>
        <v-layout column layout-col-height5 overflow-auto>
          <div class="widget-container">
            <DxFileUploader
              id="uploaderContainer"
              :ref="dxFileUploader"
              accept="*"
              :multiple="true"
              :max-file-size="maxFileSize"
              upload-mode="useButtons"
              upload-url="/api/file/multiUpload?desc="
              :upload-custom-data="uploadermultiData"
              selectButtonText="Select File"
              labelText=""
              @uploaded="onUploaded"
              @upload-error="onUploadError"
              @startedUpload="onStartedUpload"
              @value-changed="onValueChanged"
            />
          </div>
          <v-col cols="12" md="12" class="row pa-0">
            <v-col cols="12" lg="12" class="mt-2">
              <DxDataGrid
                id="fileDataGrid"
                class="layout-col-height5-body"
                :ref="dxFileDataGridRef"
                :data-source="files"
                :remote-operations="false"
                :hover-state-enabled="true"
                :allow-column-resizing="true"
                :allow-column-reordering="true"
                :row-alternation-enabled="true"
                :column-auto-width="true"
                :show-borders="true"
                :show-row-lines="true"
                key="fileId"
              >

                <DxSelection 
                  :select-all-mode="allMode" 
                  show-check-boxes-mode="always" 
                  mode="multiple" />

                <DxColumn
                  data-field="fileId"
                  caption="파일아이디"
                  width="200px"
                  data-type="string"
                  alignment="center"
                  css-class="devest-grid-header-require"
                />

                <DxColumn
                  data-field="fileNm"
                  caption="파일이름"
                  width="200px"
                  data-type="string"
                  alignment="center"
                  css-class="devest-grid-header-require"
                />

                <DxColumn
                  data-field="extension"
                  caption="파일확장자"
                  width="200px"
                  data-type="string"
                  alignment="center"
                  css-class="devest-grid-header-require"
                 />

                <DxColumn 
                  data-field="createdAt" 
                  data-type="string" 
                  caption="파일등록일자" 
                  width="200px" 
                  alignment="center" />

                <DxColumn 
                  data-field="createdBy" 
                  data-type="string" 
                  caption="파일등록자" 
                  width="200px" 
                  alignment="center" />

                <DxColumn 
                  data-field="fileDesc" 
                  caption="비고" 
                  data-type="string" 
                  alignment="center" />

                <template #checkBoxEditor="{ data: cellInfo }">
                  <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onCheckValueChanged(value, cellInfo)" />
                </template>
              </DxDataGrid>
            </v-col>
          </v-col>
        </v-layout>
      </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxMasterDetail,
  DxSelection,
} from 'devextreme-vue/data-grid';

import AdvancedDetailView from './AdvancedDetailView.vue';
import { DxFileUploader } from 'devextreme-vue/file-uploader';
import { getFile,getFileList,deleteFile,download,getTargetList } from '@/api/baseManage/fileUpload'
import notify from 'devextreme/ui/notify'


export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxMasterDetail,
    AdvancedDetailView,
    DxFileUploader,
    DxSelection,
  },
  props: {
    masterDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      suppliersData: [],
      maxFileSize : 1073741824, 
      dxDataGridRef:"targetDataGrid",
      dxFileDataGridRef:"fileDataGrid",
      dxFileUploader:"uploaderContainer",
      allowedFileExtensions: ['.jpg', '.jpeg', '.gif', '.png'],
      fileData:[],
      uploadermultiData:{},
      files: [],
    };
  },
  computed:{
    fileUploader: function() {
      return this.$refs[this.dxFileUploader].instance;
    },
    fileGridData: function(){
      return this.$refs[this.dxFileDataGridRef].instance;
    }
  },
  beforeMount() {
    
  },
  methods : {
    click() {
        console.log("설정값", this.masterDetailData)
        console.log("값", this.masterDetailData.data)
    },
    onUploaded(e) {
      e.component._files.forEach((element,index) => {
        if(element._isLoaded){
          this.fileUploader.removeFile(index)
        }
      });
      notify(this.$t("파일이 업로드 되었습니다."), "success", 300); 
    },
    onUploadError(e){
      e.component._files.forEach((element,index) => {
        if(element._isError){
          this.fileUploader.removeFile(index)
          notify(this.$t("파일을 업로드 할 수 없습니다."), "error", 300); 
        }
      });
    },
    onStartedUpload(){
      
    },
    onValueChanged(e){
      this.fileUploader.repaint()
      let fileLen
      //파일이름 길이 체크
      e.component._files.forEach((element,index)=>{
        if(element.value.name.length>200){
          e.component._uploadButton._$element.remove()
          element.uploadButton._$element.remove()
          element.$statusMessage[0].firstChild.nodeValue = "File Name is too long"
          element.$file[0].className += ' dx-fileuploader-invalid'
        }
        let subFileName = this.getExtension(element.value.name)
        let newRow={
          fileId:this.files.length+1, 
          file:element, 
          fileNm:subFileName[0], 
          extension:subFileName[1], 
          fileSize: element.value.fileSize
        }
        console.log(newRow)

        this.files.ushift(newRow)
      })
      
      
      console.log(this.files)
      console.log("onValueChanged", e)
    },
    fileRemove(file){
      this.$vToastify.prompt({
        body: "파일을 삭제하시겠습니까?",
        answers: { Yes: true, No: false }
      }).then(value =>{
        if(!value) return
        else{
          deleteFile(file)
            .then(res => {
              if(res.success){
                this.btnSearch()
                notify(this.$t("파일이 삭제되었습니다."), "success", 300); 
              }
            }) .catch((error) => {
              if(error.response.data.code == null){
                this.$vToastify.error({body: this.$t("errorToastMsg")+": "+this.$t("errorToastServerClose")}) 
              } else{
                console.log(error)
                this.$vToastify.error({body: this.$t("errorToastID")+": "+this.$t(error.response.data.code)+"<br>"+this.$t("errorToastMsg")+": "+this.$t(error.response.data.msg)}) 
              }
            }) .finally(() => {
          })
        }
      })
    },
    getExtension(fileName){
      let fileLen = fileName.length;

      let lastDot = fileName.lastIndexOf('.')
      let extension = fileName.substring(lastDot+1,fileLen)
      let baseName = fileName.substring(0,lastDot)
      return [baseName,extension]
    } 

  }
};
</script>

<style>
.widget-container {
  margin-right: 320px;
}

.contents h4 {
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 18px;
}

.contents {
  margin-top: 50px;
  margin-left: 10px;
  display: none;
}

.fileList{
  padding: 10px;
  width: 400px;
  background-color: rgba(183, 183, 183, 0.1);
}

.fileNm{
  height: 20px;
  font-weight: bold;
}

.fileList > .fileSize{
  height: 20px;
  font-size: 12px;
}
</style>
